import axios from "axios";
import api, { ApiResponse } from "../../api"
import { TerminalsTilesLoadingStatusSummary } from "./TerminalsTilesModel";

export const REQUEST_ID: {
  [key: string]: string;
} = {
  GET_TERMINALSTILES_PREVIEW: "get_terminalstiles_preview",
};

class TerminaltilesService {
  private source: any;
  private static instance: TerminaltilesService;
  private constructor() {
    this.source = {};
  }
  static getInstance(): TerminaltilesService {
    if (!TerminaltilesService.instance) {
      TerminaltilesService.instance = new TerminaltilesService();
    }
    return TerminaltilesService.instance;
  };

  public cancelRequest = (requestId: string) => {
    this.source[requestId] && this.source[requestId].cancel();
  }

  public getTerminalTilesPreview = async (
  ): Promise<ApiResponse<TerminalsTilesLoadingStatusSummary>> => {
    
    this.cancelRequest(REQUEST_ID.GET_TERMINALSTILES_PREVIEW);
    this.source[REQUEST_ID.GET_TERMINALSTILES_PREVIEW] = axios.CancelToken.source();
    return await api.get(`/terminals/summary-counts`, { cancelToken: this.source[REQUEST_ID.GET_TERMINALSTILES_PREVIEW].token });
  };
};

export default TerminaltilesService;
